export function getLocalStorage(key: string) {
  const value = window.localStorage.getItem(key);
  return value;
}

export function setLocalStorage(key: string, value: string) {
  window.localStorage.setItem(key, value);
}
